import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Surveys.css';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import {
  paginationInfoSelector,
  pendingTotalSelector,
  surveysSelector,
} from 'components/admin/surveys/store/selectors';
import PropTypes from 'prop-types';
import { getSurveys, goToSurvey } from 'components/admin/surveys/store/actions';
import SurveysTable from 'components/admin/surveys/SurveysTable';
import SearchBar from 'components/shared/navigation/SearchBar';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';

class Surveys extends Component {
  static propTypes = {
    paginationInfo: PropTypes.shape({}),
    pendingTotal: PropTypes.number.isRequired,
    surveys: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onSurveyClick: PropTypes.func.isRequired,
    onSurveysGet: PropTypes.func.isRequired,
  };

  static defaultProps = {
    paginationInfo: null,
  };

  constructor(props) {
    super(props);
    this.selectedNavigator = 1;
  }

  componentDidMount() {
    this.props.onSurveysGet();
  }

  handlePageChange = (page) => {
    if (this.selectedNavigator === 1) {
      this.props.onSurveysGet(page);
    } else {
      this.props.onSurveysGet(page, true);
    }
  };

  handleNavSelection = (value) => {
    this.selectedNavigator = value;
    this.handlePageChange(1);
  };

  handleGenerateLink = (index) => {
    const { surveys } = this.props;
    return `surveys/${surveys[index].id}`;
  };

  render() {
    const {
      currentUser,
      paginationInfo,
      pendingTotal,
      surveys,
      onSurveyClick,
    } = this.props;
    const isClient = usersUtil.hasType(currentUser, TYPES.CLIENT);
    return (
      <div className="surveys">
        <div className="full-title">Surveys</div>
        <div className="content-container">
          <SearchBar>
            <NavigationBar
              items={[
                {
                  id: 1,
                  title: 'All',
                },
                {
                  id: 2,
                  show: pendingTotal > 0,
                  title: 'Pending',
                  total: pendingTotal,
                },
              ]}
              onSelected={this.handleNavSelection}
            />
          </SearchBar>
          <SurveysTable
            showClient={!isClient}
            surveys={surveys}
            onRowSelected={(index) => onSurveyClick(surveys[index].id)}
            onGenerateLink={this.handleGenerateLink}
          />
          {paginationInfo !== null && (
            <div className="pagination-container">
              <SimplePagination
                currentPage={paginationInfo.currentPage}
                pageSize={paginationInfo.pageSize}
                total={paginationInfo.total}
                onPageChange={(page) => this.handlePageChange(page)}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: getCurrentUser(state),
    paginationInfo: paginationInfoSelector(state),
    pendingTotal: pendingTotalSelector(state),
    surveys: surveysSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSurveyClick: (surveyId) => {
    dispatch(goToSurvey(surveyId));
  },
  onSurveysGet: (page, pending) => {
    dispatch(getSurveys(page, pending));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Surveys);



// WEBPACK FOOTER //
// ./src/components/admin/surveys/Surveys.js